import React, { useState } from "react";

const AddTable = (props) => {
  const [data] = useState([props.values]);
  return (
    <div className="addnew-table">
      <h3 style={{ marginBottom: "1rem" }}>{props.label}</h3>
      <div className="table">
        {/* <div className="t-wrap"> */}
        <div className="thead">
          <div className="tr">
            {props.columns?.map((ele) => {
              return (
                <div className="td" style={{ width: ele.width + "%" }}>
                  {ele.header}
                </div>
              );
            })}
          </div>
        </div>
        <div className={`tbody`}>
          {data?.map((item) => (
            <div className="tr">
              {props.columns.map((ele) => {
                return (
                  <div
                    className={`td ${ele.className ? ele.className : ""}`}
                    style={{ width: ele.width + "%" }}
                  >
                    <input name={ele.key} value={item[ele.key]} />
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
      <div className="addNew">
        <span>+ Add New</span>
      </div>
    </div>
  );
};

export default AddTable;
